const requestOnIdleCallback = (toExecute: any) => {
    if (window.requestIdleCallback) {
        window.requestIdleCallback(() => toExecute(), { timeout: 1000 });
    } else {
        toExecute();
    }
};

export { requestOnIdleCallback };
